<template>
  <div>
    <vx-card v-if="form != null">
      <h3>Booth Members</h3>
      <vue-json-to-table :data="memberList"></vue-json-to-table>
      <table>
        <tr>
          <td>First Name</td>
          <td>Last Name</td>
          <td>Email</td>
          <td>Type</td>
          <td>Status</td>
        </tr>
        <tr v-for="(item, index) in memberList" :key="index">
          <td>{{ item.firstname }}</td>
          <td>{{ item.lastname }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.attendee_type }}</td>
          <td>{{ item.attendee_status }}</td>
        </tr>
      </table>

      <p class="text-center">For Souloutt Team Only</p>
      <vue-json-to-table :data="form"></vue-json-to-table>
    </vx-card>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    valid: true,
    form: {},
    filterList: [],
    memberList: [],
  }),
  created() {
    setTimeout(() => {
      Service.Booth.get(this.id, this.$route.query.e).then((res) => {
        this.form = res.data;
        Service.Booth.getMembers(this.form.booth.company.slug, {
          e: this.$route.query.e,
        }).then((members) => {
          this.memberList = members.data.rows;
        });
      });
    }, 1000);
  },
  methods: {
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "speaker",
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then((res) => {
        this.filterList = res.data.rows;
      });
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form,
      };

      /*
      this.$vs.loading();
      Service.Speaker.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.$router.push("/conferences/speakers");
        }
        this.$vs.loading.close();
      });
      */
    },
  },
};
</script>